import { useController, useFormContext } from "react-hook-form";
import { registerLocale } from "react-datepicker";
import { InputLabel } from "../InputLabel/InputLabel";
import { InputErrorMessage } from "../InputErrorMessage/InputErrorMessage";

import pl from "date-fns/locale/pl";
import { useState } from "react";
import { BaseDatepicker } from "./BaseDatepicker";

//@ts-ignore - registerLocale is not typed
registerLocale("pl", pl);

interface PaziaDateRangeSelectProps {
  onChange?: (dates: [Date | null, Date | null]) => void;
  fromName: string;
  toName: string;
  label?: string;
  required?: boolean;
}
export const PaziaDateRangeSelect = ({
  fromName,
  toName,
  onChange,
  ...rest
}: PaziaDateRangeSelectProps) => {
  const { control } = useFormContext();
  const { field: fromField } = useController({ name: fromName, control });
  const { field: toField } = useController({ name: toName, control });

  const onChangeHandler = (dates: [Date | null, Date | null]) => {
    const [from, to] = dates;
    from?.setHours(12);
    to?.setHours(12);
    fromField.onChange(from);
    toField.onChange(to);
    if (onChange) onChange(dates);
  };

  return (
    <div>
      <DateRangeSelect
        {...rest}
        fromName={fromName}
        toName={toName}
        defaultValue={[fromField.value ?? null, toField.value ?? null]}
        onChange={onChangeHandler}
      />
      <InputErrorMessage name={fromName} />
      <InputErrorMessage name={toName} />
    </div>
  );
};

interface DateSelectProps {
  disabled?: boolean;
  openToDate?: Date;
  fromName: string;
  label?: string;
  defaultValue?: [Date | null, Date | null];
  required?: boolean;
  toName: string;
  range?: [Date, Date];
  onChange: (dates: [Date | null, Date | null]) => void;
  className?: string;
}

export const DateRangeSelect = ({
  label,
  required,
  fromName,
  defaultValue = [null, null],
  onChange: propsOnChange,
  className = "",
}: DateSelectProps) => {
  const [startDate, setStartDate] = useState<Date | null>(defaultValue[0]);
  const [endDate, setEndDate] = useState<Date | null>(defaultValue[1]);

  const onChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    start?.setHours(12);
    end?.setHours(12);
    setStartDate(start);
    setEndDate(end);
    propsOnChange(dates);
  };

  return (
    <div className={`w-full ${className}`}>
      <InputLabel label={label} required={required} name={fromName} />

      <BaseDatepicker<true>
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
      />
    </div>
  );
};
